module.exports = __webpack_public_path__ + "static/img/12.f28c704.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/zh/12.png
// module id = jAXT
// module chunks = 0